import { Alert } from '@design-system/components/alert/alert';
import { Button } from '@design-system/components/button/button';
import { Col, Row } from '@design-system/components/grid/grid';
import { SideModal } from '@design-system/components/modal/sideModal';
import { Typography } from '@design-system/components/typography/typography';
import { EditPlatformBundleVM } from '../../viewModel/editPlatformBundle.vm';
import {
  messageWrapper,
  promoteWrapper,
  wrapper,
  ctaWrapper,
  limitWrapper,
} from './PlatformBundleModal.css';
import { Divider } from '@mui/material';
import { ExternalLink } from '@design-system/components/link/externalLink';

export const PlatformBundleModal = ({
  isOpen,
  close,
  ...p
}: EditPlatformBundleVM['platformBundleModal']) => {
  return (
    <SideModal
      isOpen={isOpen}
      onClose={close}
      noSpacing
      testId="platformBundleModal"
    >
      <div className={wrapper}>
        <Typography variant="headline" size="small">
          Platform users
        </Typography>
        <Price />
        <Divider />
        <Alert
          variant="info"
          title="What are platform users?"
          customComponent={
            <div className="inline">
              <Typography variant="span" size="medium" fontWeight="normal">
                Some users who use Playbook Platform still have access to your
                subscription based on the old pricing and revenue split. You can
                read more about it
              </Typography>{' '}
              <ExternalLink
                label="here"
                textColor="P-80"
                textVariant="span"
                textSize="medium"
                href="https://help.playbookapp.io/en/articles/13622542-how-to-use-push-notifications-to-upsell-to-exclusive"
              />
            </div>
          }
        />
        <Promote {...p} />
      </div>
    </SideModal>
  );
};

const Price = () => (
  <Row>
    <Col>
      <Typography variant="body" size="large">
        Price per month
      </Typography>
      <Typography variant="body" size="large">
        $14.99
      </Typography>
    </Col>
    <Col>
      <Typography variant="body" size="large">
        Price per year
      </Typography>
      <Typography variant="body" size="large">
        $99.99
      </Typography>
    </Col>
  </Row>
);

const Promote = ({
  cta,
  message,
  sentOn,
  count,
}: Pick<
  EditPlatformBundleVM['platformBundleModal'],
  'cta' | 'message' | 'sentOn' | 'count'
>) => (
  <div className={promoteWrapper}>
    <Row>
      <Col>
        <Typography variant="body" size="large">
          Promote your Exclusive Subscription to Platform users
        </Typography>
        <Typography variant="body" size="medium" fontWeight="normal">
          Use the link below and/or the Push notification feature to encourage
          your current Platform users to either switch to your Exclusive
          subscription, or add it on top of their Platform subscription.
        </Typography>
      </Col>
    </Row>
    <div className={limitWrapper}>
      {sentOn && (
        <div className={messageWrapper}>
          <Typography variant="body" size="medium" fontWeight="normal">
            Push notification has been sent on {`${sentOn}`}
          </Typography>
          <Typography>{message}</Typography>
        </div>
      )}
      <Typography variant="body" size="small" fontWeight="normal" color="N-60">
        Push notification limit {count}/2
      </Typography>
    </div>
    <div className={ctaWrapper}>
      {cta.map(({ label, onClick, disabled }) => (
        <Button
          key={label}
          onClick={onClick}
          variant="text"
          size="medium"
          disabled={disabled}
        >
          {label}
        </Button>
      ))}
    </div>
  </div>
);
